import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switch-group--vertical" }
const _hoisted_2 = { class: "switch-group__item" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Manage Settings ")
const _hoisted_4 = { class: "switch-group__item" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Read Players ")
const _hoisted_6 = { class: "switch-group__item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Manage API Tokens ")
const _hoisted_8 = { class: "switch-group__item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Administrator ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_switch = _resolveComponent("base-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_base_switch, {
        disabled: _ctx.permissions.administrator,
        modelValue: _ctx.permissions.manageSettings,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.permissions.manageSettings) = $event))
      }, null, 8, ["disabled", "modelValue"])
    ]),
    _createElementVNode("label", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_base_switch, {
        disabled: _ctx.permissions.administrator,
        modelValue: _ctx.permissions.readPlayers,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.permissions.readPlayers) = $event))
      }, null, 8, ["disabled", "modelValue"])
    ]),
    _createElementVNode("label", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_base_switch, {
        disabled: _ctx.permissions.administrator,
        modelValue: _ctx.permissions.manageApiTokens,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.permissions.manageApiTokens) = $event))
      }, null, 8, ["disabled", "modelValue"])
    ]),
    _createElementVNode("label", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_base_switch, {
        modelValue: _ctx.permissions.administrator,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.permissions.administrator) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}